export const styles = (theme) => ({
  root: {
    display: 'flex',
    flex: 1
  },
  row: {
    margin: theme.spacing(1),
    minWidth: '20vw'
  },
  formControl: {
    margin: theme.spacing(3)
  },
  select: {
    marginLeft: '40px !important'
  }
});
